export default {"src":"/_next/static/media/es.7b9639f7.svg","height":500,"width":750};